import moment from 'moment';
import { PresetStatusColorType } from 'antd/lib/_util/colors';
import { ICS2InformationExchangeMessages } from 'store/declarations/eu/ics2/ICS2InformationExchangeMessages';
import { Ics2ReferralStatus, Ics2ReferralType } from 'store/declarations/eu/ics2/customs-requests/types';

const requestTitles: Record<string, string> = {
    [ICS2InformationExchangeMessages.IE3Q02]: 'Additional Information Request',
    [ICS2InformationExchangeMessages.IE3Q03]: 'HRCM Screening Request',
};

export const getRequestTitle = (messageType: string): string => requestTitles[messageType] ?? messageType;

export const getRequestTagStatus = (messageType: string): PresetStatusColorType =>
    messageType === ICS2InformationExchangeMessages.IE3Q03 ? 'warning' : 'processing';

export const formatRequestIssueDate = (issuedAt?: string): string | undefined =>
    issuedAt ? moment(issuedAt).format('DD.MM.YYYY, HH:mm') : undefined;

const referralTypeLabels: Record<string, string> = {
    [Ics2ReferralType.RFI]: 'Request for information',
    [Ics2ReferralType.RFS]: 'Request for HRCM screening',
    [Ics2ReferralType.AMD]: 'Request to amend ENS filing',
};

export const getReferralTypeLabel = (requestType?: string): string =>
    (requestType && referralTypeLabels[requestType]) || requestType || '-';

const referralStatusLabels: Record<Ics2ReferralStatus, string> = {
    [Ics2ReferralStatus.ACTION_REQUIRED]: 'Action required',
    [Ics2ReferralStatus.RESPONSE_IN_PROGRESS]: 'Draft',
    [Ics2ReferralStatus.RESPONSE_QUEUED]: 'Sending',
    [Ics2ReferralStatus.RESPONSE_BLOCKED]: 'Send failed',
    [Ics2ReferralStatus.RESPONSE_REJECTED]: 'Not accepted for processing',
    [Ics2ReferralStatus.RESPONSE_SENT]: 'Sent to customs',
    [Ics2ReferralStatus.AMENDMENT_PENDING]: 'Awaiting amendment outcome',
    [Ics2ReferralStatus.RESOLVED_BY_IE3R02]: 'Answered with IE3R02',
    [Ics2ReferralStatus.RESOLVED_BY_IE3R03]: 'Answered with IE3R03',
    [Ics2ReferralStatus.RESOLVED_BY_AMENDMENT]: 'Answered by amendment',
};

export const getReferralStatusLabel = (status?: Ics2ReferralStatus): string =>
    (status && referralStatusLabels[status]) || 'Action required';

const referralStatusColors: Record<Ics2ReferralStatus, PresetStatusColorType> = {
    [Ics2ReferralStatus.ACTION_REQUIRED]: 'warning',
    [Ics2ReferralStatus.RESPONSE_IN_PROGRESS]: 'default',
    [Ics2ReferralStatus.RESPONSE_QUEUED]: 'processing',
    [Ics2ReferralStatus.RESPONSE_BLOCKED]: 'error',
    [Ics2ReferralStatus.RESPONSE_REJECTED]: 'error',
    [Ics2ReferralStatus.RESPONSE_SENT]: 'success',
    [Ics2ReferralStatus.AMENDMENT_PENDING]: 'processing',
    [Ics2ReferralStatus.RESOLVED_BY_IE3R02]: 'success',
    [Ics2ReferralStatus.RESOLVED_BY_IE3R03]: 'success',
    [Ics2ReferralStatus.RESOLVED_BY_AMENDMENT]: 'success',
};

export const getReferralStatusColor = (status?: Ics2ReferralStatus): PresetStatusColorType =>
    (status && referralStatusColors[status]) || 'warning';

export const hasReferralBeenAnswered = (status?: Ics2ReferralStatus): boolean =>
    status === Ics2ReferralStatus.RESPONSE_QUEUED ||
    status === Ics2ReferralStatus.RESPONSE_SENT ||
    status === Ics2ReferralStatus.RESOLVED_BY_IE3R02 ||
    status === Ics2ReferralStatus.RESOLVED_BY_IE3R03 ||
    status === Ics2ReferralStatus.RESOLVED_BY_AMENDMENT;
